import React from 'react';
import {useInternationalization} from '@progress/kendo-react-intl';

import {IGridCell} from "../../../../ui/types/IGridCell";

import './numericCell.scss';

const NumericCell: React.FC<IGridCell> = ({rowType, dataItem, format, field, style, scale, className, isPercent}) => {
    const intl = useInternationalization();
    const item = field && dataItem[field];

    if (rowType === 'groupHeader') {
        return null;
    }

    if (item === undefined) return <td/>;

    const formatNumber = () => {
        if (format) {
            return item === null ? '' : intl.toString(item, format);
        } else {
            if (typeof item === 'object' && item !== null) {
                return item.rowAmount === null ? '' : intl.toString(item.rowAmount, (isPercent ? 'p' : 'n') + scale || item.scale);
            } else {
                const index = field?.lastIndexOf('_');
                let objectField = field && field.substring(0, index);
                let objectItem = dataItem[objectField];
                return objectItem?.rowAmount === null ? '' : intl.toString(objectItem?.rowAmount, (isPercent ? 'p' : 'n') + scale || objectItem?.scale);
            }
        }
    };

    return (
        <td style={style} className={className ? className : ''}>
            <div
                className='numeric-cell alignment-right'>{formatNumber()}</div>
        </td>
    );
};

export default NumericCell;
